import { styled, Typography } from "@mui/material";

export const StyledSublabel = styled(Typography)({
  fontSize: "1rem",
  marginTop: "5px",
});
